import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  standalone: true,
  name: 'mark'
})
export class MarkPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any, args?: any): any {
    try {
      if (!args) {
        return value;
      }
      const strValue = value.toString();
      // search the value global (not just first match)
      const re = new RegExp(args, 'gi');
      const match = strValue.match(re);

      // no match, just return the original value
      if (!match) {
        return value;
      }

      if (!strValue?.length) {
        return strValue;
      }

      const replacedValue = strValue.replace(match[0], '<mark>' + match[0] + '</mark>');

      return this.sanitizer.sanitize(SecurityContext.HTML, replacedValue);
      // return this.sanitizer.bypassSecurityTrustHtml(replacedValue);
    } catch (e) {
      return value;
    }
  }
}
